import { useConfig as libUseConfig } from '@ibe/components';
import type AlbConfigModel from '@/Config/AlbConfigModel';

const useConfig = (): AlbConfigModel => {
  return libUseConfig() as AlbConfigModel;
};

export default useConfig;
